import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Link, navigate } from "@reach/router";
import {
  Title,
  Paragraph,
  SubTitle,
  DocImage,
  DocImages,
  NavigateButton,
  DocPaper,
  DocLink,
  Panel,
  Text,
  TextButton,
  TabWithContent,
  useDynamicImage,
  SimpleGallery
} from "../../../DocCreater";

//本文档的引用图片存放的位置
const imageFolder = "/images/learnpage/step5/";

//资源库库介绍
const IntroPanel = props => {
  return (
    <TabWithContent
      content={[
        {
          title: "实验步骤",
          detail: (
            <>
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou13-1.jpg`} />
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou13-2.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤13:</Text>
                点击导航栏“构件认知”栏目，进入构件详情，可以看到构件图纸照片、构件条文栏目中的“+”按钮，点击即可弹出表单，填写表单字段即可向数据库内加入该构件的图纸照片及条文；学生应当在以上步骤操作完毕，对于清官式大木作基础知识牢固掌握的前提下，配合课程田野踏查实习，在实地考察时记录建筑细节照片，通过自主研读清式营造文献，摘录整理条文；最终在教师指导下将资源录入实验项目教学资源库，从实验项目的使用者转变为实验项目资源的建设者。
              </Paragraph>
            </>
          )
        },
        {
          title: "资源建设",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">清官式大木作教学资源库:</Text>
                教学资源库是整个实验项目的数据支撑，资源库设计架构如下图，学生在熟练掌握清官式大木作基础知识与建筑构造后，即可通过自主踏查文物建筑拍摄建筑构件照片、阅读清官式营造文献整理文献内容，将研究学习的成果在线加入教学资源库，提升学生自主学习研究积极性，同时保障教学资源库的持续建设。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}ziyuanku.jpg`} />

              <DocImage imageSrc={`${imageFolder}steps.jpg`} />

              <Paragraph>
                以学生为中心，学生不仅仅是教学资源及虚拟实验的使用者，也是建设者，培养了学生研究整理营造文献、现场考察记录建筑的能力，提升学生的学习积极性，完成了整个教学流程的闭环。
              </Paragraph>
              <Text color="primary">资源建设权限</Text>
              <Paragraph>
                <Text color="secondary">构件信息:</Text>
                构件信息是整个教学系统的基础，也是其他信息的关联外键，因此仅有教师可新增修改或删除构件信息。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">营造文献:</Text>
                为了确保营造文献选择质量与教学资源建设计划可控，营造文献由教师选定，发布在营造文献列表中，学生即可在上传条文时文献选择栏内看到新增文献，仅有教师可新增修改或删除营造文献。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">营造条文:</Text>
                营造条文学生均可创建，学生可修改或删除自己创建的条文，但是不可修改删除他人创建的条文，教师可以修改删除任何人所创建的条文。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">图纸照片:</Text>
                图纸照片学生均可创建，学生可修改或删除自己创建的图纸照片，但是不可修改删除他人创建的图纸照片，教师可以修改删除任何人所创建的图纸照片。
              </Paragraph>
            </>
          )
        },

        {
          title: "建设路线",
          detail: (
            <>
              <Paragraph>
                实验项目已纳入本学科教学体系，后续将会得到持续性建设投入，计划后续按年份分期建设实验项目内教学资源库、实景教学资源、虚拟搭建资源三个部分内容，同时按计划开发方便学生使用的移动端app，开放数据接口调用api。详细持续建设计划如下：
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}build.jpg`} />
            </>
          )
        }
      ]}
    />
  );
};

function Step5(props) {
  return (
    <DocPaper>
      <Title>清官式大木作教学资源库建设</Title>
      <IntroPanel />
    </DocPaper>
  );
}

export default Step5;
